import { API, API_GET_ID } from "../../Config";

export const GetAnalyticsData = () => {
  return API_GET_ID(API.GetAnalytics);
};
